/**
 * empty-connection.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Connection } from "./connection";

export class EmptyConnection extends Connection<any> {
  constructor ()
  {
    super();
  }

  protected launch () : void
  {
    // Nothing
  }

  public close () : void
  {
    throw new Error("Cannot close EmptyConnection!");
  }

  public send () : void
  {
    throw new Error("Cannot send using EmptyConnection!");
  }
  public sendRaw () : void
  {
    this.send();
  }
}

export const EMPTY : Connection<any> = new EmptyConnection();



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/connection/empty-connection.ts